<div class="container-fluid">
    <div class="row pt-5 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
        <div class="col-sm-8">
            <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
                <span>Pending Diary Weeks - Team</span>
            </h5>
        </div>
        <div class="col-sm-2">
            <button class="btn btn-sm btn-block btn-outline-theme" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
            </button>
        </div>
        <div class="col-sm-2">
            <button class="btn btn-sm btn-block btn-outline-theme" (click)="exportToExcel()">
                <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
        </div>
    </div>
    <div class="container" id="mainContent">
        <div *ngIf="reportList.length>0">
            <div class="row justify-content-center text-center pt-3">
                <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
                </span>
            </div>
            <div class="row justify-content-center text-center ">
                <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
            </div>


            <div class="row justify-content-center text-center mt-2">
                <span class="bg-theme-title">Pending Diary Weeks - Team</span>
            </div>
            <!-- <div class="row justify-content-center text-center">
        <span class="bg-theme-title">AsgForFY : {{ selectedFinancialYear.name }}</span>
      </div> -->
            <div class="pt-2 pb-2">
                <table class="table table-bordered table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Week Start Date</th>
                            <th>Week End Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let employee of reportList">

                            <ng-container *ngFor="let week of employee.weekDetails; let i = index">

                                <tr>
                                    <td *ngIf="i === 0" [attr.rowspan]="employee.weekDetails.length + 1">
                                        {{ employee.name }}
                                    </td>

                                    <td>{{ week.weekStartDate | date:'dd/MM/yyyy' }}</td>
                                    <td>{{ week.weekEndDate | date:'dd/MM/yyyy' }}</td>
                                </tr>

                                <!-- Total Row -->
                                <tr *ngIf="i === employee.weekDetails.length - 1" class="total-row">
                                    <td><b>Total</b></td>
                                    <td><b>{{ employee.weekDetails.length }} Week(s)</b></td>
                                </tr>

                            </ng-container>

                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>